import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import { API } from "aws-amplify";


import Loader from 'components/Loader'

import ShowInfo from "components/shows/ShowInfo";

import { onError, Notification } from "libs/errorLib";
import { useAppContext } from "libs/contextLib";

import { getIpGeo } from 'libs/ipgeo';
import config from 'config';

import "../../../node_modules/noty/lib/noty.css";
import "../../../node_modules/noty/lib/themes/bootstrap-v4.css";
// import "containers/Show.css";
import "./FestivalComedia.css"

export default function Site(props) {
  const { id, ...otherProps } = props
    
  const history = useHistory(); 
//   const { id } = useParams();  
  const {isAuthenticated, getSession, updateCartCounter } = useAppContext();
  const [show, setShow] = useState(null);
  const [childShows, setChildShows] = useState(null);
  
  const [isLoading, setIsLoading] = useState(false);
    
  let session = null
  
    useEffect(() => {

    async function onLoad() {
        try {           
            setIsLoading(true)
            session = await getSession()            
            
            const show = await loadShow();
            setShow(show)

            const children = await loadChildShows();            
            setChildShows(children)
            
        } catch (e) {
            onError(e);
        } finally {
            setIsLoading(false)
        }
    }

    onLoad();
    }, [id]);

    /* API CALLS  */

    async function loadShow() {
        return API.get("vivelo", `/shows/${id}`);
    }
    async function loadChildShows() {
        const children = await API.get("vivelo", `/shows/?parent=${id}&filter=ALL`);        
        return children && children.items ? children.items : []
    }

    return (
        !isLoading && show ? <>
        <div className="site-festivalcomedia2020">                        
            <div className="body">
                <h1><img src="https://assets.viveloonline.com/shows/festivalcomedia202012/festival-comedia.png" /></h1>
                <div className="events">
                    { childShows && childShows.map(s => {                        
                        return <Link key={`name-${s._id}`} to={`/shows/${s._id}`}>
                        <div className="movie">
                            <div className="poster" ><img src={s.settings.poster_image} alt={s.settings.title} /></div>
                            <div className="info">
                            <div>
                                <div className="title"><b>{s.settings.title}</b></div>
                                <div className="genre">{s.settings.year}</div>
                            </div>
                            {/* <div>
                                <div className="month">Nov</div>
                                <div className="date">{s.settings.date}</div>
                            </div> */}
                            </div> 
                        </div></Link>
                    })}
                    
                </div>
            </div>
        </div>
        </> : <Loader />
  );
}